import type { FC } from "react"

// @ts-expect-error - no types
import FPSStats from "react-fps-stats"
import { useRecoilValue } from "recoil"

import { usePortal } from "~/components/ui"

import { DesignerDebugPanel, enableFpsStatsState } from "./DesignerDebugPanel"
import { debugPanelIsPresentState } from "./state"

export const DebugPortal: FC = () => {
  const showDebug = useRecoilValue(debugPanelIsPresentState)
  const { Portal } = usePortal({
    elementId: `designer-dev-tools`,
    initial: true,
  })
  const showFpsStats = useRecoilValue(enableFpsStatsState)

  return showDebug ? (
    <Portal>
      {showFpsStats ? <FPSStats /> : null}
      <DesignerDebugPanel />
    </Portal>
  ) : null
}
